var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSelectSearchArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#ffffff",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7074 8.98815C12.3168 8.59768 11.6837 8.5977 11.2932 8.98821L6.69712 13.5843C6.30669 13.9747 6.30672 14.6078 6.69701 14.9984C7.0875 15.3892 7.721 15.3894 8.11162 14.9988L11.2972 11.8133C11.6877 11.4227 12.3208 11.4227 12.7114 11.8133L15.8968 14.9987C16.2872 15.3891 16.9204 15.3882 17.3097 14.9967C17.6975 14.6067 17.6966 13.9765 17.3077 13.5877L12.7074 8.98815Z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectSearchArrowUp);
export default __webpack_public_path__ + "static/media/select-search-arrow-up.e0ce1beffc143fa71ede82dd0a61ca94.svg";
export { ForwardRef as ReactComponent };